exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1eAX_{padding-top:5px;border-top:1px solid #e6e6e6}._1eAX_>span{padding:10px 25px;text-align:left;text-transform:uppercase}._1eAX_>span a{color:#00dcb2}._1eAX_>span:first-child{padding-right:5px}._1eAX_>span:last-child{padding:10px}", ""]);

// exports
exports.locals = {
	"languageSwitcher": "_1eAX_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"minimize":true,"discardComments":{"removeAll":true},"localIdentName":"[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/components/LanguageSwitcher/LanguageSwitcher.scss
// module id = 742
// module chunks = 2